import { useLayoutEffect, useRef, useState } from 'react';
import {
    clippingViewRect,
    collectScrollParents,
    pinnedRailBox,
    type PinnedRailBox,
} from '../../utils/pinnedRail';

export function usePinnedRail(enabled: boolean, messageCount: number) {
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const [pin, setPin] = useState<PinnedRailBox>({ top: 0, left: 0, height: 0 });

    useLayoutEffect(() => {
        if (!enabled)
            return undefined;

        const wrapper = wrapperRef.current;
        if (!wrapper)
            return undefined;

        const scrollParents = collectScrollParents(wrapper);

        const update = () => {
            const wrapperRect = wrapper.getBoundingClientRect();
            const viewRect = clippingViewRect(wrapper);
            setPin(pinnedRailBox(wrapperRect, viewRect, messageCount));
        };

        const onScroll = () => update();
        scrollParents.forEach((node) => node.addEventListener('scroll', onScroll, { passive: true }));
        window.addEventListener('scroll', onScroll, { capture: true, passive: true });
        window.addEventListener('resize', update);
        const observer = new ResizeObserver(update);
        observer.observe(wrapper);
        scrollParents.forEach((node) => observer.observe(node));
        update();

        return () => {
            scrollParents.forEach((node) => node.removeEventListener('scroll', onScroll));
            window.removeEventListener('scroll', onScroll, { capture: true });
            window.removeEventListener('resize', update);
            observer.disconnect();
        };
    }, [enabled, messageCount]);

    return { wrapperRef, pin };
}
